import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { toast } from "sonner";
import { COPY } from "@/config/copy";
import useAnalysisPolling from "@/hooks/useAnalysisPolling";

const PHASE_ANIMATION = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
  transition: { duration: 0.6, ease: [0.2, 0.8, 0.2, 1] },
};

const BAR_ANIMATION = {
  initial: { x: "-100%" },
  animate: { x: "100%" },
  transition: { repeat: Infinity, duration: 1.6, ease: "linear" },
};

const PHASE_INTERVAL_MS = 1800;

export default function Cinematic({ answers, lead, onDone, onError }) {
  const c = COPY.cinematic;
  const [phase, setPhase] = useState(0);

  // Rotate the loading phrase every 1.8s.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const t = setInterval(() => setPhase((p) => (p + 1) % c.phases.length), PHASE_INTERVAL_MS);
    return () => clearInterval(t);
  }, []);

  useAnalysisPolling({
    answers,
    lead,
    onDone,
    onError: (msg) => {
      toast.error(msg);
      onError();
    },
  });

  return (
    <div className="relative z-10 min-h-screen flex items-center justify-center px-8 md:px-16">
      <div className="max-w-2xl w-full">
        <div className="section-label mb-8">{c.heading_label}</div>
        <div className="h-32 md:h-40 relative overflow-hidden" data-testid="cinematic-phase">
          <AnimatePresence mode="wait">
            <motion.div
              key={phase}
              {...PHASE_ANIMATION}
              className="absolute inset-0 font-serif text-3xl md:text-5xl font-light leading-tight display-tight"
            >
              {c.phases[phase]}
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-12 relative h-[2px] w-full bg-[#E5E5E5] overflow-hidden">
          <motion.div {...BAR_ANIMATION} className="absolute inset-y-0 w-1/3 bg-[#9fa5a3]" />
        </div>

        <div className="section-label mt-8">{c.hold_note}</div>
      </div>
    </div>
  );
}
